import { notify } from './message';
import ValidationError from '../utilites/networkErrors/ValidationError';

export function handleError(error) {
  return dispatch => {
    if ( error instanceof ValidationError ) {
      error.getTranslatedMessages()
        /*eslint  no-console: 0*/
        .catch(data => console.error(data))
        .then(errors => {
          if (errors.base) {
            dispatch(notify(errors.base));
          } else {
            return Promise.reject(error)
          }
        })
    } else {
      dispatch(notify('Something going wrong'));
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/error.js